import React, { useState } from "react";
import { ChevronRight } from "lucide-react";

const FAQSection = () => {
  const [openFAQ, setOpenFAQ] = useState(null);
  const [query, setQuery] = useState("");

  const faqs = [
    {
      q: "What services do you offer?",
      a: "We offer comprehensive software development services including web development, mobile apps, and custom solutions.",
    },
    {
      q: "Do you provide custom web development?",
      a: "Yes, we specialize in custom web development tailored to your specific business needs.",
    },
    {
      q: "How should I get started?",
      a: "Simply contact us through our form or give us a call to schedule a free consultation.",
    },
  ];

  const handleQuerySubmit = () => {
    alert("Thank you for your query! We will get back to you soon.");
    setQuery("");
  };

  return (
    <div className="py-16 bg-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid md:grid-cols-2 gap-10 items-center">
          {/* LEFT CONTENT */}
          <div>
            <p className="text-orange-500 font-semibold mb-2">
              Frequently asked questions
            </p>

            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold mb-6">
              We're here to change your business look
            </h2>

            <div className="space-y-4">
              {faqs.map((faq, idx) => (
                <div key={idx} className="border-b pb-4">
                  <button
                    onClick={() => setOpenFAQ(openFAQ === idx ? null : idx)}
                    className="w-full flex justify-between items-center text-left font-semibold hover:text-orange-500"
                  >
                    <span className="pr-4">{faq.q}</span>
                    <ChevronRight
                      className={`transition-transform ${
                        openFAQ === idx ? "rotate-90" : ""
                      }`}
                    />
                  </button>

                  {openFAQ === idx && (
                    <p className="mt-2 text-gray-600 text-sm sm:text-base">
                      {faq.a}
                    </p>
                  )}
                </div>
              ))}
            </div>

            {/* QUERY INPUT */}
            <div className="mt-8 flex flex-col sm:flex-row gap-4">
              <input
                type="text"
                placeholder="Enter your query..."
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="w-full px-4 py-3 border rounded-full focus:outline-none focus:border-orange-500"
              />
              <button
                onClick={handleQuerySubmit}
                className="bg-orange-500 text-white px-8 py-3 rounded-full hover:bg-orange-600 transition-colors whitespace-nowrap"
              >
                Submit →
              </button>
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="relative h-72 sm:h-80 md:h-96 rounded-lg overflow-hidden hidden md:block">
            <img
              src="/FAQ.png"
              alt="faq"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
